import { createClient } from "@supabase/supabase-js"

// ⚠️ Reemplaza con tus claves reales
const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || "https://rkfsuwvgiigihkeatsbq.supabase.co";
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY || "";

// Crear cliente global
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
